export const LabelProps = {
  className: "color-navy-dark dsg-Small",
  style: { textTransform: 'uppercase' }
}

function ReadOnlyRow({label, body, enterPrompt, onEditing, isLast}) {
  const style = isLast ? null : { marginBottom: 18 }
  const displayBody = body ?
    (<div className="dsg-Body">{body}</div>) :
    (
      <div
        className="dsg-Body color-navy"
        onClick={onEditing}
        style={{ cursor: 'pointer' }}
      >
        {enterPrompt}
      </div>
    )

  return (
    <div style={style}>
      <div {...LabelProps}>{label}</div>
         {displayBody}
    </div>
  )
}

export default ReadOnlyRow



// WEBPACK FOOTER //
// ./src/scripts/components/customer/CompanyCard/ReadOnlyRow.js